<template>
  <div class="dashboard__card">
    <CardLoading v-if="loaders.dashboardData"></CardLoading>
    <div class="dashboard__card-content" :class="{ 'loadingBlur': loaders.dashboardData }">
      <div class="dashboard__card-header">
        <div class="dashboard__card-title">Fuel Utilization</div>
        <span class="dashboard__card-title-addendum">{{ dateRangeText }}</span>
        <div class="dashboard__card-title-icon dashboard__card-title-icon--fuel-utilization"><i class="fa fa-tasks"></i></div>
      </div>
      <div class="row dashboard__card-body dashboard__card-body--bordered">
        <div class="dashboard__grid dash-fuel-utilization__content-container">
          <div class="col-sm-12 dashboard__card-body-col dashboard__card-body-col--fuel-utilization">
            <div class="row hearing-aid-sales__filters dash-fuel-utilization__date-range">
              <div class="filter-sales-dates__from-date filter-selection">
                <div class="filter-selection__title">From:</div>
                <div class="filter-selection__body">
                  <Datepicker
                      class="filter-selection__select filter-selection__select--date filter-selection__select--left"
                      name="select-month-from"
                      placeholder="From"
                      v-model="fuelUtilDateFrom"
                      format="MMM yyyy"
                      minimum-view="month"
                      :disabled="fuelUtilDisabledRangeFrom">
                  </Datepicker>
                </div>
              </div>

              <div class="filter-sales-dates__to-date filter-selection">
                <div class="filter-selection__title">To:</div>
                <div class="filter-selection__body">
                  <Datepicker
                      class="filter-selection__select filter-selection__select--date filter-selection__select--left"
                      name="select-month-to"
                      placeholder="To"
                      v-model="fuelUtilDateTo"
                      format="MMM yyyy"
                      minimum-view="month"
                      :disabled="fuelUtilDisabledRangeTo">
                  </Datepicker>
                </div>
              </div>

              <div class="filter-sales-dates__submit filter-selection">
                <div class="filter-selection__title">&nbsp;</div>
                <div class="filter-selection__body">
                  <div class="dashboard__card-link h-center-align h-clear" @click.prevent="getFuelUtilization">
                    <a class="dashboard__card-link-text" @click.prevent>Load</a>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div v-if="dashboardData.hoursWorked > -1">
                <div class="dash-fuel-utilization__time-stat">
                  <div class="dash-fuel-utilization__hours"> {{ dashboardData.hoursWorked }}</div>
                  <div class="dash-fuel-utilization__hours-worked">Hours Worked in this Period</div>
                </div>
                <div class="dash-fuel-utilization__counters">
                  <div class="dash-fuel-utilization__stats-container">
                    <div class="dash-fuel-utilization__count"> {{ dashboardData.totalWorkOrders }}</div>
                    <div class="dash-fuel-utilization__category">Total Work Orders</div>
                  </div>
                  <div class="dash-fuel-utilization__stats-container">
                    <div class="dash-fuel-utilization__count"> {{ dashboardData.activeWOs }}</div>
                    <div class="dash-fuel-utilization__category">Active<br/>work orders</div>
                  </div>
                  <div class="dash-fuel-utilization__stats-container">
                    <div class="dash-fuel-utilization__count"> {{ dashboardData.completedWOs }}</div>
                    <div class="dash-fuel-utilization__category">Completed<br/>work orders</div>
                  </div>
                </div>
                <div class="dash-fuel-utilization__order-stats">
                  <div class="dash-fuel-utilization__container dash-fuel-utilization__container--department">
                    <div class="dash-fuel-utilization__container-header">Department</div>
                    <div class="dash-fuel-utilization__dept-name" v-for="dept in dashboardData.countByType">{{ dept.Department }}</div>
                  </div>
                  <div class="dash-fuel-utilization__container dash-fuel-utilization__container--active">
                    <div class="dash-fuel-utilization__container-header">Active</div>
                    <div class="dash-fuel-utilization__active-stat"v-for="count in dashboardData.countByType">{{ count.Open }}</div>
                  </div>
                  <div class="dash-fuel-utilization__container dash-fuel-utilization__container--completed">
                    <div class="dash-fuel-utilization__container-header">Completed</div>
                    <div class="dash-fuel-utilization__completed-stat" v-for="count in dashboardData.countByType">{{ count.Completed }}</div>
                  </div>
                  <div class="dash-fuel-utilization__container dash-fuel-utilization__container--hours">
                    <div class="dash-fuel-utilization__container-header">Hours</div>
                    <div class="dash-fuel-utilization__completed-stat" v-for="count in dashboardData.countByType">{{ count.Hours }}</div>
                  </div>
                </div>
              </div>
              <div class="alert alert-warning" v-else>
                <div class="dashboard__no-data">No recent Fuel Utilization activity</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="dashboard__card-footer">
        <div class="dashboard__card-link">
          <router-link to="/fuel-utilization" class="dashboard__card-link-text">View All</router-link>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import lodash from 'lodash';
  import moment from 'moment';
  import { mapGetters } from 'vuex';
  import Datepicker from 'vuejs-datepicker';
  import CardLoading from './CardLoading.vue';

  export default {
    name: 'FuelUtilizationCard',
    components: {
      CardLoading,
      Datepicker,
    },
    data() {
      return {
        fuelUtilDateFrom: moment().subtract('3', 'months').format('YYYY-MM-DD'),
        fuelUtilDateTo: moment().format('YYYY-MM-DD'),
        limit: 9,
        includedStatuses: ['Member Review', 'In Progress', 'Complete'],
      };
    },
    async mounted() {
      await this.$store.dispatch('fuelUtilization/getDateList');
      this.fuelUtilDateTo = moment(this.dateList[0]).toDate();
      this.fuelUtilDateFrom = this.dateList.length > 3 ? moment(this.dateList[2]).toDate() : moment(this.dateList.length - 1).toDate();
      this.getFuelUtilization();
    },
    computed: {
      ...mapGetters('fuelUtilization', ['loaders', 'dateList', 'dashboardData']),
      dateRangeText() {
        return `${moment(this.fuelUtilDateFrom).format('MMM YYYY')} - ${moment(this.fuelUtilDateTo).format('MMM YYYY')}`;
      },
      fuelUtilDisabledRangeFrom() {
        return {
          to: moment(this.dateList[this.dateList.length - 1]).toDate(),
          from: this.fuelUtilDateTo ? moment(this.fuelUtilDateTo).toDate() : moment(this.dateList[0]).endOf('month').toDate(),
        }
      },
      fuelUtilDisabledRangeTo() {
        return {
          to: this.fuelUtilDateFrom ? moment(this.fuelUtilDateFrom).toDate() : moment(this.dateList[this.dateList.length - 1]).toDate(),
          from: this.dateList.length > 0 ? moment(this.dateList[0]).endOf('month').toDate() : moment().endOf('month').toDate(),
        };
      },
      fuelUtilDisabledRange() {
        return {
          from: new Date('2014-04-01'),
          to: new Date(this.fuelUtilDateTo),
        };
      },

      workOrders() {
        const workOrders = lodash.chain(this.dashboardData.workOrders)
          // we only want to include certain statuses so we remove all other work orders
          .filter(workOrder => (this.includedStatuses).includes(workOrder.portalStatus))
          // take the number of most recent work orders defined by limit
          .take(this.limit)
          // get the value from the chain
          .value();

        const workOrderObject = {};
        lodash.map(this.includedStatuses, (status) => {
          workOrderObject[status] = lodash.filter(workOrders, workOrder => workOrder.portalStatus === status);
        });

        return lodash.chain(workOrderObject)
          // convert object to an array of arrays of work orders
          .values()
          // flatten to one array
          .flatten()
          // get the value from the chain
          .value();
      }
    },

    methods: {
      /**
       * Loads Fuel Utilization metrics for the past three months
       */
      getFuelUtilization() {
        this.$store.dispatch('fuelUtilization/getDashboardWorkOrders', {
          dateFrom: moment(this.fuelUtilDateFrom).format('YYYY-MM-DD'),
          dateTo: moment(this.fuelUtilDateTo).endOf('month').format('YYYY-MM-DD'),
        });
      },
      workOrderStatusClass(status) {
        return this.includedStatuses.includes(status) ?
          `dash-fuel-utilization__work-order-status--${lodash.kebabCase(status)}` : '';
      },
    },
  };
</script>
